/**
 * Host-owned registry mapping a semantic avatar asset key to a bundled image.
 *
 * A JSON-authored surface can only carry strings, and a server author cannot
 * produce a bundler-resolved asset URI at all — the URI only exists once Metro
 * has bundled the app. So a document names the image the same way it names an
 * icon: by a semantic key the host resolves, never by a URL or transport
 * detail. The host registers its bundled assets at startup; unregistered keys
 * resolve to `undefined` so the component can degrade rather than fail.
 *
 * Registration must use a statically-analysable `require` at the call site —
 * Metro resolves asset requires at bundle time, not at runtime.
 */

/** A platform image source: a bundler asset handle (native) or a URI (web). */
export type AvatarAssetSource = number | { uri: string };

const registry = new Map<string, AvatarAssetSource>();

export function registerAvatarAsset(key: string, source: AvatarAssetSource): void {
  registry.set(key, source);
}

export function resolveAvatarAsset(key: string): AvatarAssetSource | undefined {
  return registry.get(key);
}

/** Test seam — production hosts register once at startup and never clear. */
export function clearAvatarAssets(): void {
  registry.clear();
}
